<template>
  <svg
    width="133"
    height="195"
    viewBox="0 0 133 195"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2751_1699)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M85.4653 21.4679L85.2522 22.1291L83.331 28.1737L81.7411 33.1733L70.9135 67.2068L69.3236 72.2064L68.0071 76.3472C67.4663 78.0367 65.7323 79.0359 63.9961 78.6609L27.6544 70.8108C25.9182 70.4358 24.7524 68.8044 24.956 67.0479L25.466 62.7328L26.0815 57.5227L30.2668 22.0545L30.8822 16.8444L31.6273 10.5458L31.7061 9.85547L85.4597 21.4667L85.4653 21.4679Z"
        fill="#C7D6EB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M83.3309 28.1719L81.7397 33.177L30.2711 22.0594L30.8877 16.8438L83.3309 28.1719Z"
        fill="#CBEFE1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M70.9141 67.2055L69.3242 72.2051L25.4722 62.7328L26.082 57.5215L70.9141 67.2055Z"
        fill="#CBEFE1"
      />
      <path
        d="M31.7176 0.439139L89.3412 12.8863C90.4669 13.1294 91.1775 14.2358 90.9362 15.3528L89.7226 20.9715C89.4801 22.0941 88.3717 22.8017 87.2516 22.5597L29.628 10.1126C28.5023 9.86947 27.7917 8.76311 28.033 7.64608L29.2466 2.02741C29.4879 0.910381 30.5975 0.197189 31.7176 0.439139Z"
        fill="#3E668A"
      />
    </g>
    <g clip-path="url(#clip1_2751_1699)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M107.169 71.2119L107.251 72.4492L108.047 83.7413L108.703 93.0818L113.165 156.668L113.821 166.009L114.366 173.745C114.582 176.903 112.364 179.703 109.237 180.225L43.7833 191.146C40.6563 191.668 37.6477 189.73 36.8282 186.682L34.8314 179.188L32.4198 170.141L15.9952 108.55L13.5836 99.5028L10.6698 88.5642L10.3457 87.3672L107.159 71.2135L107.169 71.2119Z"
        fill="#C7D6EB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M108.047 83.7421L108.705 93.0927L16.007 108.56L13.5938 99.502L108.047 83.7421Z"
        fill="#CBEFE1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M113.165 156.668L113.822 166.009L34.8416 179.187L32.4199 170.141L113.165 156.668Z"
        fill="#CBEFE1"
      />
      <path
        d="M4.16152 71.7426L107.945 54.426C109.972 54.0877 111.88 55.4547 112.216 57.4665L113.904 67.586C114.242 69.6079 112.869 71.5119 110.852 71.8485L7.06852 89.1651C5.04107 89.5034 3.13342 88.1364 2.79774 86.1245L1.10926 76.005C0.773581 73.9932 2.14415 72.0792 4.16152 71.7426Z"
        fill="#3E668A"
      />
    </g>
    <defs>
      <clipPath id="clip0_2751_1699">
        <rect
          width="63.1181"
          height="69.6476"
          fill="white"
          transform="translate(29.6846) rotate(12.189)"
        />
      </clipPath>
      <clipPath id="clip1_2751_1699">
        <rect
          width="112.653"
          height="124.306"
          fill="white"
          transform="translate(0.5 72.3535) rotate(-9.47273)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
